const constantsCustomEvents = {
  EmailBouncedCTAViewed: "UpdateEmailBouncedCTAViewed",
};

export default constantsCustomEvents;
